import moment from 'moment';

export default trend => {
  return trend.to === trend.from
    ? moment.utc(trend.to, moment.ISO_8601)
      .add(1, 'hour')
      .toISOString()
    : trend.to;
};